import { render, staticRenderFns } from "./approvals.vue?vue&type=template&id=39fb4330"
import script from "./approvals.ts?vue&type=script&lang=js&external"
export * from "./approvals.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports